<div class="aum-pagination-action-bar">
    <aum-select
        *ngIf="!hidePageSize && pageSizePropertyOptions.length > 1"
        size="small"
        [options]="pageSizePropertyOptions"
        (selectionChange)="onPaginationSelectionChange($event.value.id)"
        [aumFormControl]="pageSizeFormControl"
    >
    </aum-select>

    <div class="aum-paginator-range-label">{{_intl.getRangeLabel(pageIndex, pageSize, length)}}</div>

    <span class="aum-paginator-spacer"></span>

    <button
        aum-icon-button
        class="aum-paginator-icon"
        color="basic"
        icon="arrow-left-double"
        (click)="firstPage()"
        [disabled]="_previousButtonsDisabled()"
        *ngIf="showFirstLastButtons"
    ></button>

    <button
        aum-icon-button
        class="aum-paginator-icon"
        color="basic"
        icon="arrow-left"
        (click)="previousPage()"
        [disabled]="_previousButtonsDisabled()"
    ></button>

    <div
        *ngFor="let page of pages"
        [ngClass]="(page === pageIndex)?'aum-paginator-active-page-index' : 'aum-paginator-page-index'"
        (click)="jumpToPage(page)"
    >
        {{page+1}}
    </div>

    <button
        aum-icon-button
        class="aum-paginator-icon"
        color="basic"
        icon="arrow-right"
        (click)="nextPage()"
        [disabled]="_nextButtonsDisabled()"
    ></button>

    <button
        aum-icon-button
        class="aum-paginator-icon"
        color="basic"
        icon="arrow-right-double"
        (click)="lastPage()"
        [disabled]="_nextButtonsDisabled()"
        *ngIf="showFirstLastButtons"
    ></button>
</div>
